<template>
    <!--part列表-->
    <div class="content">
        <!--<div class="curr_btn">-->
            <!--<Button type="primary" @click="addPart()">添加part</Button>-->
        <!--</div>-->
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="partList"></Table>
        </div>
    </div>
</template>
<style scoped>
.content>div {
    padding: 10px 0;
}
</style>
<script>
import http from "../../libs/http.js"
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            partList: [],
            columns: [{
                    title: 'No.',
                    type: 'index',
                    align: 'center',
                },
                {
                    title: 'part名称',
                    key: 'name',
                    align: 'center',
                },
//                {
//                    title: '操作',
//                    key: 'action',
//                    render: (h, params) => {
//                        return h('div', [
//                            h('Button', {
//                                props: {
//                                    type: 'primary',
//                                    size: 'small',
//                                },
//                                style: {
//                                    marginRight: '2px'
//                                },
//                                on: {
//                                    click: () => {
//                                        this.addPart(params.row.id)
//                                    }
//                                }
//                            }, '编辑part'),
//                            h('Button', {
//                                props: {
//                                    type: 'error',
//                                    size: 'small',
//                                    disabled: this.getLimit == 1 || this.getLimit == 6 ? false : true
//                                },
//                                on: {
//                                    click: () => {
//                                        this.delete(params.row.id)
//                                    }
//                                }
//                            }, '删除')
//                        ]);
//                    }
//                }
            ],
        }
    },
    created() {
        this.getPart()
    },
    methods: {
        //获取part列表
        getPart() {
            let that = this;
            that.loading = true;
            http.post('/custom/partInfo/list', {
                status: 0,
            }).then(res => {
                that.loading = false;
                that.partList = res
            })
            .catch(error => {
                console.error(error)
            });
        },
        // 点击添加/编辑part事件
        addPart(id) {
            if (id) {
                this.$router.push({ path: 'editPart', query: { partId: id } })
            } else {
                this.$router.push({ path: 'addPart' })
            }
        },
        //点击删除事件
        delete(id) {
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '确定删除该part?',
                onOk: () => {
                    http.post('/custom/partInfo/del', {
                        id: id
                    }).then(res => {
                        if (res) {
                            that.getPart()
                            that.$Message.success('删除成功');
                        }
                        
                    })
                }
            });
        },
    },
    computed: {
        ...mapGetters([
            'getLimit',
        ])
    },
}
</script>